/**
 * Shared dispatch constants. Extracted from `pages/Dispatch.jsx` so that
 * sub-components in `components/dispatch/*` can import them without
 * importing from the parent page (which would risk circular imports as
 * Dispatch.jsx imports the components back).
 */

export const DISPATCH_STATUS_LABEL = {
  scheduled: "Scheduled",
  en_route: "En Route",
  on_site: "On Site",
  done_for_day: "Done",
  completed: "Complete",
};
